import FormInput from '../templates/FormInput';
import { FormItemProps } from '../templates/FormProps';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';

const ProcedureName = ({
  name = 'name',
  label = 'Procedure Name',
  placeholder = 'Enter Procedure Name',
  rules,
  required = true,
  disabled,
  ...props
}: FormItemProps) => {
  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return <FormInput {...{ name, label, placeholder, disabled }} rules={rulesMemo} {...props} />;
};

export default ProcedureName;
